<template>
  <v-dialog
    v-model="OpenDialogShowEmails"
    persistent
    max-width="1500"
    :scrollable="true"
  >
    <v-card style="height: 80vh;">
      <v-card-title>
        <v-row>
          <v-col cols="10">
            <v-row>
              <v-col cols="2">
                <v-img :src="emailImg" max-width="40" he alt=""> </v-img>
              </v-col>
              <v-col cols="10">
                <span>
                  Emails
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="2"
            style="text-align: end; cursor: pointer;"
            @click="closeModal"
          >
            <v-icon left color="#858C94">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="height: 400px;">
        <v-container>
          <v-row>
            <v-col cols="10">
              <v-text-field
                class="share-bar-clase"
                label="Buscar"
                outlined
                dense
                prepend-inner-icon="mdi-magnify"
                :light="true"
                v-model="filtro"
              ></v-text-field>
            </v-col>
            <v-col
              cols="2"
              style="text-align: end; cursor: pointer;"
              @click="openCreateModal"
            >
              <v-icon left dense color="#0070C0">
                mdi-plus-circle-outline
              </v-icon>
            </v-col>
          </v-row>
          <v-expansion-panels
            class="pb-5"
            v-for="(email, idx) in todosLosCorreos"
            :key="idx"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-row>
                  <v-col cols="5" style="align-self: center;">
                    <h4>
                      {{ email.subject }}
                    </h4>
                  </v-col>
                  <v-col cols="3" style="align-self: center;">
                    {{ (email.dateFormat) }}
                  </v-col>
                  <v-col
                    cols="2"
                    style="align-self: center;"
                    v-if="email.documentos.length > 0"
                  >
                    <v-btn icon :href="email.url_documento">
                      <v-icon color="#029ECF">
                        mdi-paperclip
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-html="email.cuerpo"></div>
                <v-row class="pt-4" v-if="email.documentos.length > 0">
                  <v-col cols="12">
                    <h4>
                      Documentos adjuntos
                    </h4>
                  </v-col>
                </v-row>
                <v-row
                  v-for="(atachment, indx) in email.documentos"
                  :key="indx"
                >
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Nombre documento
                          </th>
                          <th class="text-left">
                            Fecha
                          </th>
                          <th class="text-left">
                            Descargar
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(doc, i) in atachment.documentos" :key="i">
                          <td>{{ doc.nombre }}</td>
                          <td>{{ getFormatDate(doc.fechaCreacion) }}</td>
                          <td>
                            <v-btn icon :href="doc.urlBucket">
                              <v-icon color="#C1C7CD">
                                mdi-arrow-down-bold
                              </v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-row>
              </v-expansion-panel-content>
              <v-expansion-panel-content>
                <v-row class="pt-4">
                  <v-col cols="12">
                    <h4>
                      Creado por: {{ email.remitente }} el:
                      {{
                        email.dateFormat ||
                          $timezone.formatServerTimezone(email.fecha)
                      }}
                    </h4>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
      <v-card-actions style="justify-content: center;">
        <div
          style="display: flex; justify-content: center; align-items: center;"
        >
          <v-pagination
            v-model="page"
            :length="pages"
            circle
            color="#0070C0"
          ></v-pagination>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import emailImg from "@/assets/email.svg";
import moment from "moment";

export default {
  components: {},
  props: {
    OpenDialogShowEmails: {
      type: Boolean,
      default: false,
    },
    emails: Array,
    correosSegurify: Array,
  },

  data() {
    return {
      requiredRule: [(v) => !!v || "El campo es requerido"],
      data: {
        nombre: null,
        enviarPorCorreo: false,
        nota: null,
        tipo: "Nota",
        tipo_documento: null,
      },
      run: false,
      formData: null,
      page: 1,
      limit: 5,
      filtro: null,
      emailImg: emailImg,
    };
  },

  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    openCreateModal() {
      this.$emit("openCreateModal");
    },
    getFormatDate(date) {
      return moment(date)
        .subtract(6, "hours")
        .format("DD/MM/YYYY");
    },
    
  },
  computed: {
    pages() {
      if (!this.emailsFiltrados) return 1;
      const totalPages = Math.ceil(this.emailsFiltrados.length / this.limit);
      return totalPages < 1 ? 1 : totalPages;
    },
    emailsFiltrados() {
      if (!this.filtro) {
        return this.correosSegurify;
      }
      const filtroMin = this.filtro.toLowerCase().trim();
      return this.correosSegurify.filter((nota) => {
        return nota.nota.toLowerCase().includes(filtroMin);
      });
    },
    indiceInicio() {
      return (this.page - 1) * this.limit;
    },
    indiceFinal() {
      return this.page * this.limit - 1;
    },
    showNotes() {
      return this.emailsFiltrados.slice(
        this.indiceInicio,
        this.indiceFinal + 1
      );
    },
    todosLosCorreos() {
      return this.correosSegurify.concat(this.emails);
    },
  },
};
</script>

<style scoped>
.custom-list {
  background-color: #0058fc;
  border-radius: 10px;
  text-align: center;
  margin: 5px 0px 5px 0px;
}

.v-expansion-panel {
  background-color: rgb(165, 55, 238);
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 5px !important;
  background-color: aliceblue;
}
.v-expansion-panel-header {
  background-color: aliceblue;
  border-radius: 5px;
}
</style>
